import MusicOffIcon from '@mui/icons-material/MusicOff';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import { Box, SvgIcon, Typography } from '@mui/material';
import {
  ColumnsPanelTrigger,
  DataGrid,
  GridColDef,
  GridRenderCellParams,
  Toolbar,
  ToolbarButton,
} from '@mui/x-data-grid';
import { LocalTrack } from 'models/LocalTrack';
import { useTranslation } from 'react-i18next';

export interface TrackListProps {
  trackList: LocalTrack[];
  actions?: (params: GridRenderCellParams<LocalTrack>) => JSX.Element;
  // actions?: (
  //   params: GridRowParams<LocalTrack>
  // ) => readonly React.ReactElement<GridActionsCellItemProps>[];
  highlightRow?: (row: LocalTrack) => boolean;
}

function TrackListToolbar() {
  return (
    <Toolbar>
      <ColumnsPanelTrigger render={<ToolbarButton />}>
        <ViewColumnIcon fontSize="small" />
      </ColumnsPanelTrigger>

      {/* <ExportCsv render={<ToolbarButton />}>
        <FileDownloadIcon fontSize="small" />
      </ExportCsv> */}

      {/* <QuickFilter>
        <QuickFilterControl
          render={({ ref, ...controlProps }, state) => (
            <TextField
              {...controlProps}
              inputRef={ref}
              size="small"
              placeholder="Suchen…"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon fontSize="small" />
                  </InputAdornment>
                ),
              }}
            />
          )}
        />
      </QuickFilter> */}
    </Toolbar>
  );
}

export function TrackList(props: TrackListProps) {
  const { t } = useTranslation();
  const columns: GridColDef[] = [
    { field: 'title', headerName: 'Title', flex: 1 },
    { field: 'artist', headerName: 'Artist', flex: 1 },
    { field: 'bpm', headerName: 'BPM', minWidth: 80 },
    { field: 'path', headerName: 'Path', flex: 1 },
  ];

  if (props.actions) {
    columns.push({
      field: 'actions',
      type: 'actions',
      headerName: '',
      sortable: false,
      minWidth: 80,
      renderCell: props.actions,
    });
  }

  if (!props.trackList.length) {
    return (
      <Box
        sx={{
          justifyContent: 'center',
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          p: 10,
        }}
      >
        <Box color="textDisabled">
          <SvgIcon color="disabled" sx={{ fontSize: 80 }}>
            <MusicOffIcon />
          </SvgIcon>
        </Box>
        <Typography variant="h2" color="textDisabled">
          {t('noTracksFound', 'No tracks found...')}
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <DataGrid
        sx={{ border: 0 }}
        rows={props.trackList}
        getRowId={(row) => row.id + (row.path || '')}
        // getRowId={(row) => JSON.stringify(row)}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 100,
            },
          },
          columns: {
            columnVisibilityModel: {
              bpm: false,
              key: false,
              collection: false,
              genre: false,
              path: false,
            },
          },
          filter: {
            filterModel: {
              items: [],
            },
          },
        }}
        // More than 100 is only available with DataGridPro
        // 'All' with { value: -1, label: 'All' } is working though, but causes performance issues with large datasets
        pageSizeOptions={[25, 50, 100]}
        disableColumnMenu
        disableRowSelectionOnClick
        showToolbar
        slots={{
          toolbar: TrackListToolbar,
        }}
        getRowClassName={(params): string =>
          props.highlightRow?.(params.row as LocalTrack) ? 'row-highlight' : ''
        }
      />
    </Box>
  );
}
